import React, {
  Fragment,
} from 'react';
import {
  makeStyles,
} from '@mui/styles';

import { getStatusList } from '../lib'
import {
  colorInProgress,
  colorCompleted,
  colorFinished,
  colorSettled,
  colorCanceledOrder,
  colorCanceledAllocation,
} from './'

const useStyles = makeStyles(() => ({
  icon: {
    paddingTop: 3,
  },
  inProgress: {
    marginLeft: 5,
    color: colorInProgress,
  },
  completed: {
    marginLeft: 5,
    color: colorCompleted,
  },
  finished: {
    marginLeft: 5,
    color: colorFinished,
  },
  settled: {
    marginLeft: 5,
    color: colorSettled,
  },
  canceledOrder: {
    marginLeft: 5,
    color: colorCanceledOrder,
  },
  canceledAllocation: {
    marginLeft: 5,
    color: colorCanceledAllocation,
  },
}));

export default function Status(props: any) {
  const classes = useStyles();
  const { status } = props;

  let statusText = ''
  getStatusList().map(s => {
    if (s.id === status) statusText = s.status
  })

  const statusColorObject = {
    0: classes.inProgress,
    1: classes.completed,
    2: classes.finished,
    3: classes.settled,
    10: classes.canceledOrder,
    11: classes.canceledAllocation,
  }
  // @ts-ignore
  const statusColor = statusColorObject[status]

  const iconColorObject = {
    0: colorInProgress,
    1: colorCompleted,
    2: colorFinished,
    3: colorSettled,
    10: colorCanceledOrder,
    11: colorCanceledAllocation,
  }
  // @ts-ignore
  const iconColor = iconColorObject[status]

  return (
    <Fragment>
      <svg height="14" width="14" className={classes.icon}>
        <circle cx="6" cy="6" r="4" stroke={iconColor} strokeWidth={'1'} fill={iconColor}/>
      </svg>
      <strong className={statusColor}>{statusText}</strong>
    </Fragment>
  )
}